export default {"src":"/_next/static/media/manage.81ce1bb2.svg","height":215,"width":241,"blurWidth":0,"blurHeight":0};